import React from "react";

export const TopbarContext = React.createContext<any>({});
export const SupportContext = React.createContext<any>({})